module.exports = __webpack_public_path__ + "static/img/mars3logo.da36461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mars3logo.png
// module id = GFg8
// module chunks = 0